import React, { useCallback, useMemo, useState } from "react";
import np from "../../../../../shared/Images/no_photo.jpg"
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/image.css'
import { useAppContainerContext } from "../../../../revised_components/appContainer/context";
import { useNotificationContext } from "../../../../revised_components/contextProviders/notificationContext";
import { PRE_IMG } from "../../../../../shared/Data/typeDirs";
import { PreambleImage } from "../../../../../shared/Objects/newReportObjects/preambleImage";
import { dataSource } from "../../../../../services/dataSource";
import { useSource, useSourceReducer } from "../../../sourceContext";
import { useControl, useControlReducer } from "../../../controlContext";
import { usePhotoManagerContext } from "../../../../revised_components/contextProviders/photoManagerContext";
import { useUserContext } from "../../../../revised_components/contextProviders/userContext";
import {Spinner} from 'react-bootstrap'
// import { ProgressElement } from "../../../../revised_components/progressElement";
// import { filesGetThumbnailBatch } from "../../../../../services/dropboxRequests";
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { getThumbnails } from "../../../../../services/networkRequests";
import { genId } from "../../../../../shared/utils";
import { Input, FormLabel, Textarea } from '@mui/joy';


export function ImageControl({ idx, name, displaySettings = {}, objectMetadata, label, placeholder, options = { thumbnailSize: 'md' } }) {
  const { [idx]: block } = useControl()
  const { imageMap } = useSource()
  // const { [name]: {_id: value } } = block
  const { isDragging, setIsDragging, setProgress } = useAppContainerContext()
  const { user } = useUserContext()
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[block._id])), [allReadOnly, lockMap, block._id])
  const displayNotif = useNotificationContext()
  const controlReducer = useControlReducer()
  const sourceReducer = useSourceReducer()
  const { photoUploadManager } = usePhotoManagerContext()
  const [draggingOver, setDraggingOver] = useState(false)
  const [loading, setLoading] = useState(false)

  // function progressCallback(status) {
  //   if (!status.isRunning) {
  //     setProgress(false)
  //     return
  //   }
  //   setProgress(
  //     ProgressElement(status.num, status.den, `Moving images from DBGallery: (${status.num} / ${status.den})`)
  //   )
  // }

  const dropImage = useCallback(async (evt) => {
    setLoading(true)
    setIsDragging(false)
    let data = evt.dataTransfer.getData('text')
    let paths = evt.dataTransfer.files
    let maybeArray = data.split(',')
    let length = Math.max(maybeArray.length, paths.length)
    if (length !== 1) { return displayNotif('danger', 'Please drop exactly one image.') }
    displayNotif('info', `Adding image...`);

    let isDBGallery = Array.isArray(maybeArray) && maybeArray.every(itm => (itm.length && itm.length <= 8))
    let newImageId = genId()
    let newImage = new PreambleImage({
      _id: newImageId,
      parentType: objectMetadata.type,
      _parentId: objectMetadata._id,
      dbg_id: isDBGallery ? maybeArray[0] : null,
      dropboxPath: !isDBGallery ? PreambleImage.getDropboxArchivePath(newImageId, objectMetadata.dirName, objectMetadata.type) : null,
      thumbnailSize: options.thumbnailSize,
      storageLocation: isDBGallery ? 'dbgallery' : 'dropbox'
    })
    let newMapImageData
    console.debug('dropped stuff', isDBGallery, data, maybeArray, paths, evt.dataTransfer.items)
    let queueItem
    if (isDBGallery) {
      if (maybeArray.length > 1) {
        displayNotif('danger', 'Please drop only one image.')
        return
      }
      // setDraggingOver(false)
      [newMapImageData, queueItem] = await dbgalleryPutImageAndGetThumbs(maybeArray[0], newImage, objectMetadata, options.thumbnailSize, user.token)
    } else {
      if (paths.length > 1) {
        displayNotif('danger', 'Please drop only one image.')
        return
      }
      [newMapImageData, queueItem] = await localPutImageAndGetThumbs(paths[0], newImage, objectMetadata, options.thumbnailSize, photoUploadManager, setProgress, user.token)
    }

    sourceReducer({
      type: 'update_imageMap',
      imageData: newMapImageData, name: 'image',
      photo_update: [queueItem]
    })
    setTimeout(() => {
      controlReducer({
        idx, name, type: 'changed', update: {
          [name]: newImage
        },
      })
      setDraggingOver(false)
      setLoading(false)
    })
  }, [options, objectMetadata, photoUploadManager, user, setProgress, name, idx, displayNotif, controlReducer, sourceReducer])


  const handleDragEvent = useCallback((evt) => {
    evt.stopPropagation()
    evt.preventDefault()
    // console.log('handling drag event', evt.type)
    // return
    if (evt.type === 'drop') return dropImage(evt)
    setDraggingOver(evt.type === 'dragover' ? true : false)
  }, [dropImage])


  const [imageData, value] = useMemo(() => {
    const val = block && block[name] && block[name]._id
    const image = imageMap && imageMap[val]
    // console.log('making new imageData', name, !!image, val, imageMap)
    return [image, val]
  }, [imageMap, name, block])
  let comp = useMemo(() => {

    const containerClassName = `report-pre-image-container ${displaySettings.className || ''} `
    // console.log('creating new image component', name, value, !!imageData)
    return (
      <div key={value} className={containerClassName}>
        <div style={{ marginBottom: '5px' }} hidden={!label}>
          <FormLabel sx={{ m: 0 }}>{label}</FormLabel>
        </div>
        <div className={`report-pre-image-outer ${imageData ? '' : 'report-pre-image-box'} ${isDragging ? 'dragging' : ''} ${draggingOver ? ' over' : ''}`}>
          {readOnly ? [] : (
            <div className={`report-pre-image-drop-mask`}
              onDragOver={handleDragEvent}
              onDragLeave={handleDragEvent}
              onDrop={handleDragEvent}
            >
              {loading?(<Spinner  animation="border" />) : []}
            </div>
          )}
          {imageData ? (
            <div key={value} className="report-pre-image-wrapper">
              <img key={value} alt={value} className="report-pre-image" src={imageData ? `data:image/jpg;base64, ${imageData}` : np} />
            </div>
          ) : (

            <div className="report-pre-image-text">
              {`Drop Image Here (${label || placeholder})`}
            </div>

          )}
        </div>
      </div>
    )
  }, [imageData, isDragging, draggingOver, displaySettings, value, readOnly, label, handleDragEvent, placeholder])
  return comp
}

async function localPutImageAndGetThumbs(path, newImage, objectMetadata, thumbnailSize, photoUploadManager, setProgress, userToken) {
  let savedImage = await dataSource('remDb')[PRE_IMG].put(newImage)
  // console.log('got newImage', newImage, objectMetadata)
  photoUploadManager.addToQueue([{
    file: path,
    dropbox_path: savedImage.dropboxPath
  }])

  await photoUploadManager.executeQueue((prog) => setProgress(prog), userToken)
  const queueItem = {
    _id: savedImage._id,
    path: savedImage.dropboxPath,
    thumbnailSize: thumbnailSize,
    storageLocation: 'dropbox'
  }
  let thumbRes = await getThumbnails([queueItem], userToken)
  let newMapImageData = {}
  for (let res of thumbRes) {
    if (res.thumbnail) newMapImageData[res._id] = res.thumbnail

  }
  console.log('got new imageMap data from dropbox', newMapImageData, savedImage)
  return [newMapImageData, queueItem]
}

async function dbgalleryPutImageAndGetThumbs(dbg_id, newImage, objectMetadata, thumbnailSize, userToken) {

  newImage = await dataSource('remDb')[PRE_IMG].put(newImage)
  const queueItem = { dbg_id, thumbnailSize: thumbnailSize, _id: newImage._id, storageLocation: 'dbgallery' }
  let thumbnailData = await getThumbnails([queueItem], userToken)

  let newMapImageData = {}
  for (let res of thumbnailData) {
    if (res.thumbnail) newMapImageData[res._id] = res.thumbnail
  }
  console.log('got new imageMap data from dbgallery', newMapImageData, thumbnailData)
  return [newMapImageData, queueItem]
}

// function generateThumbnailRequest(image){
//   let {thumbnailSize, path, dbg_id, _id, storageLocation} = image
//   if(!dbg_id) return {path, thumbnailSize}
//   return {
//     _id,
//     dbg_id,
//     thumbnailSize,
//     storageLocation,
//   }
// }